import React, { useState, useEffect, useCallback, useRef } from "react";
import { Row, Col, message, Spin } from "antd";
import { useSelector } from "react-redux";
import { getDashboardData } from "../../core/api/dashboard";
// Import dashboard components
import TotalSalesCard from "./components/salesdashboard/total/TotalSalesCard";
import TotalCustomerCard from "./components/salesdashboard/total/TotalCustomerCard";
import TotalProfitCard from "./components/salesdashboard/total/TotalProfitCard";
import ProfitPercentageCard from "./components/salesdashboard/ProfitPercentageCard";
import AvgOrderValueCard from "./components/salesdashboard/total/AvgOrderValueCard";
import TotalRefundsCard from "./components/salesdashboard/total/TotalRefundsCard";
import RefundedOrdersCard from "./components/salesdashboard/total/RefundedOrdersCard";
import AvgRefundValueCard from "./components/salesdashboard/total/AvgRefundValueCard";
import MonthlyChart from "./components/salesdashboard/MonthlyChart";
import ProductChart from "./components/salesdashboard/ProductChart";
import SalesTypeChart from "./components/salesdashboard/SalesTypeChart";
import DailyChart from "./components/salesdashboard/DailyChart";
import OrdersChart from "./components/salesdashboard/OrdersChart";
import CategoryChart from "./components/salesdashboard/CategoryChart";
// DashboardFilters is now handled by parent component
import CustomerMetricsCard from "./components/salesdashboard/CustomerMetricsCard";
import CustomerBreakdownChart from "./components/salesdashboard/CustomerBreakdownChart";
import CostDistributionChart from "./components/salesdashboard/CostDistributionChart";
import { getProfileTest } from "../../core/api/auth";
import CostBreakdownTable from "./components/salesdashboard/CostBreakdownTable";
import "./components/DashboardStyles.css";

const SalesDashboard = ({ saleTypeFilters, userSelectedFilters }) => {
  useSelector((state) => state.toggle_header);
    
  const [dashboardData, setDashboardData] = useState({
    totalSales: 0,
    totalProfit: 0,
    profitPercentage: 0,
    totalCustomers: 0,
    salesByType: [],
    topProduct:   { name: "", subtitle: "", value: 0 },
    topCategory:  { name: "", subtitle: "", value: 0 },
    dailySales: [],
    monthlySales: [],
    customerData: {
      totalUniqueCustomers: 0,
      recentCustomers: 0,
      monoBuyers: 0,
      multiBuyers: 0,
      recentMonoBuyers: 0,
      recentMultiBuyers: 0,
      customerBreakdown: [],
      recencyBreakdown: []
    },
    costData: {
      totalCost: 0,
      costDistribution: []
    },
    // New metrics
    avgOrderValue: 0,
    totalRefunds: 0,
    totalRefundedOrders: 0,
    avgRefundValue: 0
  });

  const [loading, setLoading] = useState(false);


  const fetchDashboardData = useCallback(async () => {
    console.log("callbackcallback", userSelectedFilters)
    setLoading(true);
    try {
      let saleTypes = [];
   
      if (userSelectedFilters.saleTypes && userSelectedFilters.saleTypes.length > 0) {
        saleTypes = userSelectedFilters.saleTypes;
      } else {
        // Convert the saleTypeFilters object to an array of selected types
        saleTypes = Object.keys(saleTypeFilters).filter(key => saleTypeFilters[key]);
      }
  
      // If no sale types are selected, select all by default
      if (saleTypes.length === 0) {
        saleTypes = ['phone', 'mail', 'web', 'unknown'];
      }
      
      const filterPayload = {
        dateRange: userSelectedFilters.dateRange,
        brands: userSelectedFilters.brands || [],
        saleTypes: saleTypes,
        Product: userSelectedFilters.Product || [],
        Category: userSelectedFilters.Category || [],
        Segment: userSelectedFilters.Segment || [],
        lists: userSelectedFilters.lists || []
      };
setLoading(true);
      const response = await getDashboardData(filterPayload);
      if (response.data) {
        setDashboardData(response.data);
      }
    } catch (error) {
      message.error('Failed to load dashboard data: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  }, [userSelectedFilters, saleTypeFilters, setDashboardData, setLoading]);
  const initialRenderRef = useRef(true);
  const previousFiltersRef = useRef(null);
  useEffect(() => {

    // Always fetch data on initial render if brands are available
    if (initialRenderRef.current) {
      initialRenderRef.current = false;
      previousFiltersRef.current = JSON.stringify({
        userSelectedFilters,
        saleTypeFilters
      });
      // Fetch data on initial render
      fetchDashboardData();
      return;
    }
    
    // Check if filters have actually changed
    const currentFilters = JSON.stringify({
      userSelectedFilters,
      saleTypeFilters
    });
    
    if (currentFilters !== previousFiltersRef.current) {
      previousFiltersRef.current = currentFilters;
      fetchDashboardData();
    } else {
      console.log('Filters unchanged, skipping data fetch');
    }
  }, [userSelectedFilters, saleTypeFilters]);

    
  return (
    <div className="">
      <div className="dashboard-layout">
        {/* Filter sidebar is now in the parent component */}

        {/* Scrollable Main Content */}
        <div className="dashboard-main-full px-4">
          <div className="page-header">
            <div className="add-item">
            
            </div>
          </div>
          <div className="dashboard-content">
            {loading ? (
              <div className="loading-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', padding: '50px' }}>
                <Spin size="large" tip="Loading dashboard data..." />
              </div>
            ) : dashboardData.totalSales === 0 && dashboardData.dailySales.length === 0 && dashboardData.monthlySales.length === 0 ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', width: '100%', padding: '50px', backgroundColor: '#f0f2f5', borderRadius: '8px' }}>
                <div style={{ textAlign: 'center' }}>
                  <h2 style={{ fontSize: '24px', color: '#8c8c8c' }}>No data found</h2>
                  <p style={{ fontSize: '16px', color: '#bfbfbf' }}>Try changing your filters or selecting different date ranges</p>
                </div>
              </div>
            ) : (
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  {/* Summary Cards */}
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <TotalCustomerCard value={dashboardData.totalCustomers} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <TotalSalesCard value={dashboardData.totalSales} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <TotalProfitCard orderMetrics={dashboardData.orderMetrics} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <ProfitPercentageCard orderMetrics={dashboardData.orderMetrics} />
                    </Col>
                  </Row>
                  
                  {/* New Metrics Cards */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <AvgOrderValueCard value={dashboardData.avgOrderValue} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <TotalRefundsCard value={dashboardData.totalRefunds} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <RefundedOrdersCard value={dashboardData.totalRefundedOrders} />
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <AvgRefundValueCard value={dashboardData.avgRefundValue} />
                    </Col>
                  </Row>

                  {/* Charts & Badges */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} md={8} lg={16}>
                      <SalesTypeChart data={dashboardData.salesByType} />
                    </Col>
                    <Col xs={24} md={8} lg={8}>
                      <ProductChart data={dashboardData.topProducts} />
                    </Col>
  
                  </Row>

                  {/* Monthly & Product Charts */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} md={16} lg={16}>
                      
                    </Col>
                  </Row>

                  {/* Daily & Category Charts */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} md={12} lg={16}>
                    <MonthlyChart data={dashboardData.monthlySales} />
                    </Col>
                    <Col xs={24} md={12} lg={8}>
                      <CategoryChart data={dashboardData.topCategories} />
                    </Col>
                  </Row>
                  
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                    <DailyChart data={dashboardData.salesData || {
                        daily: dashboardData.dailySales || [],
                        monthly: dashboardData.monthlySales || [],
                        yearly: dashboardData.yearlySales || []
                      }} />
                    </Col>
                  </Row>
                  {/* Orders Chart */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <OrdersChart data={dashboardData.ordersData || {
                        daily: dashboardData.dailyOrders || [],
                        weekly: dashboardData.weeklyOrders || [],
                        monthly: dashboardData.monthlyOrders || [],
                        yearly: dashboardData.yearlyOrders || []
                      }} />
                    </Col>
                  </Row>
                  
                  {/* Customer Section */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <h3 className="section-title">Customer Analytics</h3>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                    <Col xs={24} md={12} lg={12}>
                      <CustomerMetricsCard data={dashboardData.customerData} />
                    </Col>
                    <Col xs={24} md={6} lg={6}>
                      <CustomerBreakdownChart 
                        data={dashboardData.customerData?.customerBreakdown} 
                        title="Buyer Type Breakdown" 
                        type="buyer" 
                      />
                    </Col>
                    <Col xs={24} md={6} lg={6}>
                      <CustomerBreakdownChart 
                        data={dashboardData.customerData?.recencyBreakdown} 
                        title="Customer Recency" 
                        type="recency" 
                      />
                    </Col>
                  </Row>
                  
                  {/* Cost Distribution Section */}
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24}>
                      <h3 className="section-title">Cost Analysis</h3>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                    <Col xs={24} md={12} lg={12}>
                      <CostDistributionChart 
                        data={dashboardData.costData?.costDistribution} 
                        title="Cost Distribution" 
                      />
                    </Col>
                    <Col xs={24} md={12} lg={12}>
                      <CostBreakdownTable 
                        data={dashboardData.costData?.costDistribution} 
                        title="Cost Breakdown" 
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesDashboard;
